export default __webpack_public_path__ + "static/media/cp-mn.4845750b.svg";